/**
 * QBase 연결 설정 — 오픈플로우는 QBase 플랫폼의 테넌트 시스템이다.
 *
 * REACT_APP_BE_API     : QBase 백엔드 경로. 동일 오리진(상대경로 `/qcore/home`) 이 기본 —
 *                        개발은 CRA proxy(package.json "proxy") 가, 운영은 nginx 가 8445 로 넘긴다.
 *                        절대 URL 을 넣으면 다른 오리진이 되어 CORS(sys_url 등록·재기동)와 쿠키 SameSite 가 걸린다.
 * REACT_APP_QBASE_SYS_ID: 오픈플로우 시스템 ID(QSY…). 로그인에 반드시 명시한다 —
 *                        미지정 시 백엔드가 QSY0000005(오픈데이터모델러) 로 폴백해 남의 시스템에 로그인된다.
 *
 * 값이 비어 있으면 조용히 기본값으로 대체하지 않고 시작 단계에서 실패한다 (폴백 금지).
 * 단 로컬(스탠드얼론) 모드에서는 QBase 설정이 없는 것이 정상이므로 빈 문자열을 돌려준다 —
 * 그 모드에서는 이 상수를 읽는 코드 경로 자체가 없다(services/repo.ts, services/authClient.ts 가 로컬 구현으로 간다).
 * 이 파일은 import 시점에 평가되므로(ES import 호이스팅) 조건부 import 로는 막을 수 없어 여기서 분기한다.
 */
import { IS_LOCAL } from './mode';

function required(name: string): string {
  const v = process.env[name];
  if (!v || !v.trim()) {
    if (IS_LOCAL) return '';
    throw new Error(`[qbase] 환경변수 ${name} 이(가) 설정되지 않았습니다 — frontend/.env 확인 (검토서 §6.1)`);
  }
  return v.trim();
}

export const QBASE_API = required('REACT_APP_BE_API');
export const QBASE_SYS_ID = required('REACT_APP_QBASE_SYS_ID');

/** VW_QBASE_SQ 에 등록된 채번 도메인명 (한글 dmn_nm — OPENFLOW_register.sql §1 과 동기) */
export const SEQ_DOMAIN = {
  PROJECT: '오픈플로우프로젝트ID',
  WORKFLOW: '오픈플로우워크플로ID',
} as const;

/** VW_QBASE_API 에 등록된 URI (OPENFLOW_register.sql §4 와 동기) — /qbase/** 동적 라우터 */
export const OPENFLOW_API = {
  PROJECTS: '/qbase/openflow/projects',
  WORKFLOWS: '/qbase/openflow/workflows',
  WORKFLOW_VER: '/qbase/openflow/workflowVer',
  SAVE_PROJECT: '/qbase/openflow/saveProject',
  SAVE_WORKFLOW: '/qbase/openflow/saveWorkflow',
  SAVE_WORKFLOW_VER: '/qbase/openflow/saveWorkflowVer',
} as const;

/** 조회 API 의 한글 필터 파라미터명 ([placeholder] 와 동기) */
export const QUERY_PARAM = {
  PROJECT_ID: '오픈플로우프로젝트ID',
  WORKFLOW_ID: '오픈플로우워크플로ID',
  VER_NO: '버전번호',
} as const;
